import styled from 'styled-components'

export const BackButton = styled.button`
  padding: 16px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: flex-start;
  gap: 6px;
  font-size: 13px;
  font-weight: 500;
  color: #2c3e50;
  background-color: #ffffff;
  border: 1.5px solid #e1e5e9;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;

  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 0;
    height: 0;
    border-radius: 50%;
    background: rgba(123, 173, 126, 0.1);
    transform: translate(-50%, -50%);
    transition: width 0.6s ease, height 0.6s ease;
  }

  &:hover {
    background-color: #7BAD7E;
    color: #ffffff;
    border-color: #7BAD7E;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(123, 173, 126, 0.3);
    
    &::before {
      width: 300px;
      height: 300px;
    }

    svg {
      transform: scale(1.1);
    }
  }

  &:active {
    transform: translateY(0);
    box-shadow: 0 2px 6px rgba(123, 173, 126, 0.2);
    transition: all 0.1s ease;
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 3px rgba(123, 173, 126, 0.2);
  }

  &:focus:not(:focus-visible) {
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  }

  svg {
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    font-size: 14px;
  }
`

